var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50.0 50.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1259 L0,1259 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C38.8071187,-2.53632657e-15 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 1.69088438e-15,38.8071187 0,25 C-1.69088438e-15,11.1928813 11.1928813,2.53632657e-15 25,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,0 C22,0 23.4,1.4 23.4,3.1 L23.4,20.3 C23.4,20.5 23.3,20.7 23.1,20.8 C22.9,20.9 22.7,20.9 22.5,20.8 L17.1,17.2 L3.2,17.2 C1.5,17.2 0.1,15.8 0.1,14.1 L0,3.1 C0,1.4 1.4,0 3.1,0 L20.3,0 Z M20.3,1.2 L3.1,1.3 C2.1,1.3 1.3,2.1 1.3,3.1 L1.3,14.1 C1.3,15.1 2.1,15.9 3.1,15.9 L17.2,15.9 C17.3,15.9 17.4,15.9 17.5,16 L22.1,19 L22.1,3 C22.1,2 21.3,1.2 20.3,1.2 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2,0 L1.2,6.1 L0,6.1 L0,0 L1.2,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1,0 L6.1,1.3 L0,1.3 L0,0 L6.1,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1510.0 -15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1510.0 15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 50,0 50,50 0,50 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "25.1306443%"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.000000000000712 14.99999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 23.4,0 23.4,20.875 0,20.875 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.1 C0,1.4 1.4,0 3.1,0 L20.3,0 C22,0 23.4,1.4 23.4,3.1 L23.4,20.3 C23.4,20.5 23.3,20.7 23.1,20.8 C22.9,20.9 22.7,20.9 22.5,20.8 L17.1,17.2 L3.2,17.2 C1.5,17.2 0.1,15.8 0.1,14.1 L0,3.1 Z M3.1,1.3 C2.1,1.3 1.3,2.1 1.3,3.1 L1.3,14.1 C1.3,15.1 2.1,15.9 3.1,15.9 L17.2,15.9 C17.3,15.9 17.4,15.9 17.5,16 L22.1,19 L22.1,3 C22.1,2 21.3,1.2 20.3,1.2 L3.1,1.3 Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.10000000000218 5.599999999998545)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.2,0 1.2,6.1 0,6.1 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,6.1 0,0 1.2,0 1.2,6.1 0,6.1 0,6.1",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.599999999998545 7.999999999996362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.1,0 6.1,1.3 0,1.3 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "6.1,1.3 0,1.3 0,0 6.1,0 6.1,1.3 6.1,1.3",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.eb76d8cc102358ed461cbe2565cfa8a4.svg";
export { ForwardRef as ReactComponent };